import { OutsideEnrollmentAreaStatus } from "../models/Request";

export const isStatusSuggestedEnrollment = (
  status: OutsideEnrollmentAreaStatus | null
) => {
  if (!status) return false;

  return [
    OutsideEnrollmentAreaStatus.SuggestedEnrollmentAccepted,
    OutsideEnrollmentAreaStatus.SuggestedEnrollmentRejected,
    OutsideEnrollmentAreaStatus.NotProcessed,
  ].includes(status);
};

export const isStatusDecisionSuggestedEnrollment = (
  status: OutsideEnrollmentAreaStatus | null
) => {
  if (!status) return false;

  return [
    OutsideEnrollmentAreaStatus.SuggestedEnrollmentAccepted,
    OutsideEnrollmentAreaStatus.SuggestedEnrollmentRejected,
    OutsideEnrollmentAreaStatus.Decision,
  ].includes(status);
};
